import { isPossiblePhoneNumber } from "react-phone-number-input";

import { validateDesignation } from "../../../../utils/designation";

/* Order a Web Profile — the rules, transcribed. */

/* Transcribed from `validateErrors`, message for message and in its order. */
export const validateOrder = ({
  companyName,
  addressLine1,
  city,
  state,
  country,
  email,
  phone,
}) => {
  const errors = {};

  if (String(addressLine1 ?? "").trim() === "") {
    errors.addressLine1 = "Address Line 1 is required.";
  }
  if (String(state ?? "").trim() === "") errors.state = "State is required.";
  if (String(country ?? "").trim() === "") errors.country = "Country is required.";
  if (String(companyName ?? "").trim() === "") {
    errors.companyName = "Company Name is required.";
  }
  if (String(city ?? "").trim() === "") errors.city = "City is required.";

  /* Transcribed order: the "required" message is written first and then
     overwritten by the format one, so an empty number reports the format
     complaint. Kept, because the two are one field's error. */
  if (String(phone ?? "").trim() === "") {
    errors.phone = "Phone Number is required.";
  }
  if (!isPossiblePhoneNumber(String(phone ?? ""))) {
    errors.phone = "Enter valid mobile number";
  }
  if (String(email ?? "").trim() === "") errors.email = "Email is required.";

  return errors;
};

/* Transcribed: the representative's designation is optional, so its word rules only apply once something has been typed. */
export const representativeDesignationError = (designation) =>
  (String(designation ?? "").trim() ? validateDesignation(designation) : "") || "";

/* Transcribed verbatim, including the trailing comma and the line breaks —
   this string is stored as the order's customer reference and read by a human.
   An unticked acknowledgement sends the placeholder instead. */
export const customerReference = (acknowledged, rep) => {
  if (!acknowledged) return "No reference data provided";
  return `Name: ${rep.name},
      Designation: ${rep.designation},
      Email: ${rep.email},
      Contact: ${rep.contactNumber || "N/A"},`;
};

/* The order payload, field for field. */
export const orderPayload = ({ values, type, acknowledged, rep, enterpriseId }) => ({
  companyname: values.companyName,
  address1: `${values.addressLine1} ${values.addressLine2} ${values.area} ${values.city} ${values.state}`,
  city: values.city,
  state: values.state,
  postal_code: values.postalCode,
  email: values.email,
  phone: values.phone,
  comp_des: values.description,
  countrycode: values.country,
  currency: "USD",
  payment_type: type,
  ...(acknowledged && { customerreference: customerReference(true, rep) }),
  ...(type === "enterprise" && { enterpriseID: enterpriseId }),
});

/* Transcribed: `credit` and `enterprise` place the order outright; anything
   else hands off to the payment screen. */
export const placesOrderDirectly = (type) => type === "credit" || type === "enterprise";

/* Transcribed: a member or verified company buys at the member rate; everyone
   else pays as they go. */
export const reportModeFor = (activeCompany) =>
  ["member", "verified"].includes(activeCompany?.profile_status) ? "member" : "payg";

/* Transcribed: only enterprises with credit left can spend it. */
export const spendableEnterprises = (userInfo) =>
  (userInfo?.enterprise_solutions || []).filter(
    ({ credits }) => credits !== undefined && credits !== null && credits > 0
  );

/* Transcribed: a subscription counts only when it is active AND not the
   pay-as-you-go one. */
export const activeSubscription = (user) =>
  user?.individual?.[0]?.individualSubscription?.find(
    (sub) => sub?.status === "active" && sub?.subscription_type !== "pay-as-you-go"
  );

export const EMPTY_ORDER = {
  companyName: "",
  addressLine1: "",
  addressLine2: "",
  area: "",
  postalCode: "",
  country: "",
  state: "",
  city: "",
  email: "",
  phone: "",
  description: "",
};

export const EMPTY_REPRESENTATIVE = {
  name: "",
  designation: "",
  email: "",
  contactNumber: "",
};
